import { AddonList } from '@data/models';
import ReservationItem, {
  ReservationItemAccommodation,
} from '@data/models/ReservationItem';
import { apiCall, IRequestOptions } from '../axios';

export class AddonsService {
  static search(
    params: {
      propertyId: number;
      checkin: string;
      checkout: string;
      items: ReservationItem[];
    } = {} as any,
    options: IRequestOptions = {}
  ) {
    const payload = {
      property_id: params.propertyId,
    };

    const items = params.items.filter((x) => x.model?.type === 'accommodation');
    payload['lang'] = 'en';
    for (let i = 0; i < items.length; i++) {
      const { model } = items[i];
      payload[`rooms[${i}][room_type_id]`] = model?.item.id || 0;
      payload[`rooms[${i}][package]`] = model?.item.packageId || 0;
      payload[`rooms[${i}][start_date]`] = params.checkin;
      payload[`rooms[${i}][end_date]`] = params.checkout;
      payload[`rooms[${i}][adults]`] =
        (model as ReservationItemAccommodation)?.adults || 1;
      payload[`rooms[${i}][kids]`] =
        (model as ReservationItemAccommodation)?.kids || 0;
    }

    return apiCall(AddonList)('post', '/addons', payload, options);
  }
}
